import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Icon from "./icon";
import SettingCard from "../components/setting-card";
import "./nav.scss";
import Button from "./custom-button";
import * as moment from "moment";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ClassState } from "../utils/types";
import { NetworkQualityEvaluation } from "../utils/helper";
import { usePlatform } from "../containers/platform-container";
import AgoraWebClient from "../utils/agora-rtc-client";
import { AgoraElectronClient } from "../utils/agora-electron-client";
import { isElectron, platform } from "../utils/platform";
import { useRoomState } from "../containers/root-container";
import { roomStore } from "../stores/room";
import { globalStore } from "../stores/global";
import { t } from "../i18n";
import { COPY_LINK } from "../services/ihr-meet-api";

interface NavProps {
  delay: string;
  network: string;
  cpu: string;
  role: string;
  roomName: string;
  time: number;
  showSetting: boolean;
  classState: boolean;
  onCardConfirm: (type: string) => void;
  handleClick: (type: string) => void;
}

const networkQualityIcon: { [key: string]: string } = {
  excellent: "network-good",
  good: "network-good",
  poor: "network-normal",
  bad: "network-normal",
  "very bad": "network-bad",
  down: "network-bad",
  unknown: "network-bad",
};

export function Nav({
  delay,
  network,
  cpu,
  role,
  roomName,
  time,
  handleClick,
  showSetting,
  classState,
  onCardConfirm,
}: NavProps) {
  const { NavBtn } = usePlatform();

  const handleFinish = (evt: any) => {
    onCardConfirm("setting");
  };

  const [flagClickMembers, setFlagClickMembers] = useState<boolean>(true);
  const [flagClickChat, setFlagClickChat] = useState<boolean>(true);


  return (
    <>
      {!(window.location.hash.substr(1) === '/classroom/big-class')
        ? <div className={`dark--header`}>
          <div className={`content--dark--header`}>
            <div className={`col-4`}>
              <img className={`img--icon`} src={require('../assets/images/share-icon.svg')} alt="share--icon" width="15" height="16.9"
                onClick={() => {
                  navigator.clipboard.writeText(`${COPY_LINK}/${roomStore && roomStore._state.course.roomName}`);
                  globalStore.showToast({
                    type: 'msg',
                    message: t('linkCopied'),
                  })
                }} />
              <img className={`img--icon`} src={require('../assets/images/users-icon.svg')} alt="share--icon" width="20" height="12"
                onClick={() => {
                  setFlagClickMembers(!flagClickMembers)
                  if (flagClickMembers)
                    globalStore.setActive('studentList')
                  else
                    globalStore.setActive('')
                }} />
              <img className={`img--icon`} src={require('../assets/images/chat-icon.svg')} alt="share--icon" width="18" height="18"
                onClick={() => {
                  setFlagClickChat(!flagClickChat)
                  if (flagClickChat)
                    globalStore.setActive('chatroom')
                  else
                    globalStore.setActive('')
                }} />
              {globalStore.state.newMessageCount > 0 ?
                <span className="badge badge-pill badge--red">{globalStore.state.newMessageCount}</span>
                : null}

            </div>
            <div className={`col-4`}>
              <div className={'content--logo'}>
                <div className="logo--class-room">
                  <img src={require('../assets/images/logo-class-room.png')} alt="logo--icon" width="100%" height="100%" />
                </div>
                <div> <span className={`room--name`}> {roomName} </span> </div>
              </div>
            </div>
            <div className={`col-4`}>
              <div className="network-state">
                {platform === 'web' ? <span className="net-field">{t('nav.delay')}<span className="net-field-value">{delay}</span></span> : null}
                {/* <span className="net-field">Packet Loss Rate: <span className="net-field-value">{lossPacket}</span></span> */}
                <span className="net-field net-field-container">
                  <span className={`net-field-value ${networkQualityIcon[network]}`} style={{ marginLeft: '.2rem' }}>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        : <div className="logo-container">
          <div className="left">
            <div className="class-logo"></div>
            <div className="class-title">
              {role === 'teacher' ?
                <Button className={`nav-button ${classState ? "stop" : "start"}`} name={classState ? t('nav.class_end') : t('nav.class_start')} onClick={(evt: any) => {
                  handleClick("classState")
                }} /> : null}
              <span className="room-name">{roomName}</span>
              <div className="timer">
                <Icon className="icon-time" disable />
                <span className="time">{moment.utc(time).format('HH:mm:ss')}</span>
              </div>
              <div className="network-state">
                {platform === 'web' ? <span className="net-field">{t('nav.delay')}<span className="net-field-value">{delay}</span></span> : null}
                {/* <span className="net-field">Packet Loss Rate: <span className="net-field-value">{lossPacket}</span></span> */}
                <span className="net-field net-field-container">
                  <span className={`net-field-value ${networkQualityIcon[network]}`} style={{ marginLeft: '.2rem' }}>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="menu">
            <div className={platform === 'web' ? "btn-group" : 'electron-btn-group'}>
              {platform === 'web' ?
                <>
                  {/* <Icon className="icon-setting" onClick={(evt: any) => {
              handleClick("setting");
            }}/> */}
                  {/* <Icon className="i18n-lang" onClick={(evt: any) => {
              handleClick("i18n");
            }}></Icon> */}
                </> : null
              }
              <div className="flex copy-link-button">
                <Button name={t('shareLink')} onClick={() => {
                  navigator.clipboard.writeText(`${COPY_LINK}/${roomStore && roomStore._state.course.roomName}`);
                  globalStore.showToast({
                    type: 'msg',
                    message: t('linkCopied'),
                  })
                }} />
              </div>
              <Button className="icon-exit" name={t('exit')} onClick={(evt: any) => {
                // handleClick("exit");
                handleClick("goBack");
              }} />
            </div>
            <NavBtn />
          </div>
        </div>


      }

    </>
  )
}

export default function NavContainer() {
  const { platform } = usePlatform();

  const ref = useRef<boolean>(false);

  const [time, updateTime] = useState<number>(0);

  const [timer, setTimer] = useState<any>(null);

  const history = useHistory();

  const calcDuration = (time: number) => {
    return setInterval(
      () => {
        !ref.current && updateTime(+Date.now() - time);
      },
      150,
      time
    );
  };

  const [card, setCard] = useState<boolean>(false);

  const [rtt, updateRtt] = useState<number>(0);
  const [quality, updateQuality] = useState<string>("unknown");
  const [cpuUsage, updateCpuUsage] = useState<number>(0);

  useEffect(() => {
    return () => {
      ref.current = true;
      if (timer) {
        clearInterval(timer);
        setTimer(null);
      }
    };
  }, []);

  const roomState = useRoomState();

  const me = roomState.me;

  useEffect(() => {
    const rtcClient = roomStore.rtcClient;
    if (platform === "web") {
      const webClient = rtcClient as AgoraWebClient;
      webClient.rtc.on("watch-rtt", (rtt: number) => {
        !ref.current && updateRtt(rtt);
      });
      webClient.rtc.on("network-quality", (evt: any) => {
        const quality = NetworkQualityEvaluation(evt);
        !ref.current && updateQuality(quality);
      });
      return () => {
        webClient.rtc.off("watch-rtt", () => { });
        webClient.rtc.off("network-quality", () => { });
      };
    }
    if (platform === "electron") {
      const nativeClient = rtcClient as AgoraElectronClient;
      nativeClient.on("rtcStats", ({ cpuTotalUsage }: any) => {
        !ref.current && updateCpuUsage(cpuTotalUsage);
      });
      nativeClient.on(
        "networkquality",
        (uid: number, txquality: number, rxquality: number) => {
          if (uid === 0) {
            const quality = NetworkQualityEvaluation({
              downlinkNetworkQuality: rxquality,
              uplinkNetworkQuality: txquality,
            });
            !ref.current && updateQuality(quality);
          }
        }
      );

      return () => {
        nativeClient.off("rtcStats", () => { });
        nativeClient.off("networkquality", () => { });
        nativeClient.off("audioquality", () => { });
      };
    }
  }, []);

  const courseState = roomState.course.courseState;
  const course = roomState.course;

  useEffect(() => {
    if (courseState === ClassState.STARTED && timer === null) {
      const now: number = +Date.now();
      setTimer(calcDuration(now));
    }
    if (timer && courseState === ClassState.CLOSED) {
      clearInterval(timer);
      setTimer(null);
    }
  }, [courseState]);

  const lock = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      lock.current = true;
    };
  }, []);

  const updateClassState = () => {
    if (!lock.current) {
      lock.current = true;
      roomStore
        .updateMe({
          courseState: +!Boolean(roomStore.state.course.courseState),
        })
        .then(() => {
          console.log("update success");
        })
        .catch(console.warn)
        .finally(() => {
          lock.current = false;
        });
    }
  };

  const handleClick = (type: string) => {
    if (type === "setting") {
      setCard(true);
    } else if (type === "goBack") {
      globalStore.showDialog({
        type: "goBack",
        message: t("toast.quit_room"),
      });
      localStorage.removeItem("RoomData");
      sessionStorage.removeItem("LoginRoomData");
    } else if (type === "exit") {
      globalStore.showDialog({
        type: "exitRoom",
        message: t("toast.quit_room"),
      });
      localStorage.removeItem("RoomData");
      localStorage.removeItem("fullUserData");
      localStorage.removeItem("countryCode");
      sessionStorage.removeItem("LoginRoomData");
    } else if (type === "classState") {
      updateClassState();
    } else if (type === "i18n-lang") {
      // globalStore.setLanguage()
    }
  };

  const handleCardConfirm = (type: string) => {
    switch (type) {
      case "setting":
        setCard(false);
        return;
      case "goBack":
        globalStore.removeDialog();
        return;
      case "exitRoom":
        globalStore.removeDialog();
        return;
    }
  };

  return (
    <Nav
      role={me.role}
      roomName={course.roomName}
      classState={Boolean(course.courseState)}
      delay={`${rtt}ms`}
      time={time}
      network={`${quality}`}
      cpu={`${cpuUsage}%`}
      showSetting={card}
      onCardConfirm={handleCardConfirm}
      handleClick={handleClick}
    />
  );
}
